export const STAGE_KEYS = {
  BGMAIN: 'bg-main',
  FIG_C: 'fig-center',
  FIG_L: 'fig-left',
  FIG_R: 'fig-right',
};
